import { createAction, props } from '@ngrx/store';
import { DossierWorkflow } from './dossier-workflow.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier workflow',
    props<{dossierId: string}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier workflow success', 
    props<{ listData: DossierWorkflow[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier workflow failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier workflow',
);